import ClassPage from "@/components/classPage/ClassPage";

export default [
  {
    path: "/csjy.html",
    name: "ClassPage",
    component: ClassPage,
    props: true,
    meta: {
      title:
        "软件测试零基础就业培训课程_软件测试培训机构_博为峰51Testing软件测试培训官网",
      keywords: "测试开发培训,博为峰51Testing,测试进阶",
      description:
        "测试开发培训,是博为峰51Testing开办的软件测试工程师进阶课程,致力于提升学员的自动化测试和接口测试能力,培养学员的框架设计思想,并能灵活应用工具设计框架,以支撑团队测试自动化的实现."
    }
  },
  {
    path: "/cskf.html",
    name: "ClassPage2",
    component: ClassPage,
    props: true,
    meta: {
      title:
        "软件测试开发培训_软件测试进阶培训班_博为峰51Testing软件测试培训官网"
    }
  },
  {
    path: "/zhoumo.html",
    name: "ClassPage3",
    component: ClassPage,
    props: true,
    meta: {
      title: "周末精品班_博为峰51Testing软件测试培训官网"
    }
  },
  {
    path: "/neixun.html",
    name: "ClassPage4",
    component: ClassPage,
    props: true,
    meta: {
      title: "企业测试内训_博为峰51Testing软件测试培训官网"
    }
  },
  {
    path: "/weipei.html",
    name: "ClassPage5",
    component: ClassPage,
    props: true,
    meta: {
      title: "入职企业合作_博为峰51Testing软件测试培训官网"
    }
  },
  {
    path: "/xueli.html",
    name: "ClassPage6",
    component: ClassPage,
    props: true,
    meta: {
      title: "名校专升本_博为峰51Testing软件测试培训官网"
    }
  },
  {
    path: "/renzheng.html",
    name: "ClassPage7",
    component: ClassPage,
    props: true,
    meta: {
      title: "ISTQB认证_博为峰51Testing软件测试培训官网"
    }
  },
  {
    path: "/python.html",
    name: "ClassPage8",
    component: ClassPage,
    props: true,
    meta: {
      title: "Python测试开发_博为峰51Testing软件测试培训官网"
    }
  },
  {
    path: "/mcar.html",
    name: "ClassPage9",
    component: ClassPage,
    props: true,
    meta: {
      title:
        "车载测试培训_软件测试零基础就业培训课程_软件测试培训班_博为峰51Testing软件测试培训官网"
    }
  },
  {
    path: "/ruankaom.html",
    name: "ClassPage10",
    component: ClassPage,
    props: true,
    meta: {
      title: "软考_博为峰51Testing软件测试培训官网"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/classpage.js